export default __webpack_public_path__ + "static/media/soon.f87be7fd.png";